import React from 'react';
import PropTypes from 'prop-types';

import css from 'styles/components/account/orderHistoryFindOrders.scss';

const OrderHistoryFindOrders = ({ onSearchByOrderIdSubmit, onReturnItems, returnablesAvailable }, { marketplace: { account: { multiBoxReturns, martyReturns } }, testId }) => (
  <div className={css.findOrder}>
    <div>
      <form
        method="post"
        role="search"
        aria-label="Order History"
        onSubmit={onSearchByOrderIdSubmit}
      >
        <label htmlFor="searchByOrderId" aria-label="Enter An Order Number">Search items in your order history</label>
        <div className={css.inputGroup}>
          <input
            type="search"
            id="searchByOrderId"
            placeholder="Search by Order Number"
            required
            data-test-id={testId('orderSearchBox')}/>
          <span className={css.inputGroupButton}>
            <button type="submit" data-test-id={testId('orderSearchSubmit')}>Search Orders</button>
          </span>
        </div>
      </form>
    </div>
    { martyReturns && multiBoxReturns &&
        <div>
          <button
            type="button"
            onClick={onReturnItems}
            disabled={!returnablesAvailable}
            className={css.return}
            data-test-id={testId('returnItemsButton')}>Return Items</button>
        </div>
    }
  </div>
);

OrderHistoryFindOrders.contextTypes = {
  testId: PropTypes.func,
  marketplace: PropTypes.object
};

OrderHistoryFindOrders.propTypes = {
  onSearchByOrderIdSubmit: PropTypes.func.isRequired
};

export default OrderHistoryFindOrders;
